import { useEffect, useState } from 'react';
import { usePostGetVersionsForDocumentMutation} from "../store/api/salesorderapi";

const VersionHistory = ({ doctype, docname,activityboll}) => {
  const [versionHistory, setVersionHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getVersionsForDocument] = usePostGetVersionsForDocumentMutation();

  useEffect(() => {
    const fetchVersions = async () => {
      if (doctype && docname) {
        setLoading(true);
        try {
          const response = await getVersionsForDocument({
            doctype,
            docname
          });
       
          if (response?.data?.message)
             {
            setVersionHistory(response.data.message);
          }
        } catch (err) {
          console.error("Error fetching version history:", err);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchVersions();
  }, [doctype, docname,activityboll]);
    useEffect(() => {
    // setdata(versionHistory.length);
  }, [versionHistory]);

  if (loading) return <p className="text-muted ms-3 mt-3">Loading activity...</p>;
  if (!versionHistory.length) return null;

      const formatTimeAgo = (dateString) => {
        const date = new Date(dateString);
        const now = new Date();
        const diff = (now - date) / 1000;

        const days = Math.floor(diff / (3600 * 24));
        const hours = Math.floor(diff / 3600);

        if (days > 0) return `${days} Day${days > 1 ? 's' : ''} Ago`;
        if (hours > 0) return `${hours}hr${hours > 1 ? 's' : ''} Ago`;
        return 'Just now';
    };
  return (
    <div className="position-relative ms-2 mt-3" style={{ borderLeft: "2px solid #D9D9D9" }}>
      {versionHistory.map((item, index) => (
        <div key={index} className="position-relative ps-3 mb-3">
          <div
            className="position-absolute"
            style={{
              left: '-6px',
              top: '1px',
              width: '10px',
              height: '10px',
              backgroundColor: '#F97316',
              borderRadius: '50%',
            }}
          ></div>

          {index === 0 ? (
            <div className="d-flex align-items-center mb-1">
      
              <p className="mb-0"><strong style={{fontSize:'12px'}}>{item.by}</strong>  <span style={{ fontSize: '12px',width: "100%",
    display: "block",
    overflowWrap: "anywhere" }}>{item.summary}</span></p>
            </div>
          ) : (
            <p className="mb-0 text-dark" ><strong style={{fontSize:'12px'}}>{item.by}</strong>  <span style={{ fontSize: '12px',width: "100%",
    display: "block",
    overflowWrap: "anywhere"  }}>{item.summary}</span></p>
          )}

          <p className="text-muted small mb-0" style={{fontStyle:'italic',fontSize:'13px'}}>{formatTimeAgo(item.on)}</p>
        </div>
      ))}
    </div>
  );
};

export default VersionHistory;
